module.exports = __webpack_public_path__ + "static/media/moisturising_face_mask.cf41c849.png";